import { render, staticRenderFns } from "./ColorBox.vue?vue&type=template&id=d78fafc2&scoped=true"
import script from "./ColorBox.vue?vue&type=script&lang=js"
export * from "./ColorBox.vue?vue&type=script&lang=js"
import style0 from "./ColorBox.vue?vue&type=style&index=0&id=d78fafc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78fafc2",
  null
  
)

export default component.exports